import React from "react";
import { TouchableOpacity } from "react-native";
import Text from "../Text";
// @ts-ignore
import { RedoIcon } from "myplan/components/Icon";
import { Container, Circle } from "./styles";

type RedoProps = {
	label: string;
	onPress?: () => void;
};

const Redo = ({ label, onPress }: RedoProps) => {
	return (
		<TouchableOpacity onPress={onPress}>
			<Container>
				<Circle>
					<RedoIcon width={13} height={13} color="#F7F3ED" />
				</Circle>
				<Text>{label}</Text>
			</Container>
		</TouchableOpacity>
	);
};

export default Redo;
